import gql from 'graphql-tag';
export default gql`
  mutation($deviceId: String) {
    create(deviceId: $deviceId) {
      code
    }
  }
`;
